import axios from 'axios';
import { appOperations } from '../../../../App/store';
import { createActions } from '../../CreatePage/store';
import { trackEvent, AnalyticsConstants } from '../../../../utilities/analyticsUtilities';
import types from './types';
import videosPageConstants from '../VideosPageConstants';

// DUMB ACTIONS

const setProperty = (key, value) => {
    return {
        type: types.SET_PROPERTY,
        key: key,
        value: value
    }
}

const setLoadingVideos = (loading) => {
    return {
        type: types.SET_LOADING_VIDEOS,
        loading: loading
    }
}
const updateVideos = (videos) => {
    return {
        type: types.UPDATE_VIDEOS,
        videos: videos
    }
}
const setAppendingVideos = (appending) => {
    return {
        type: types.SET_APPENDING_VIDEOS,
        appending: appending
    }
}
const appendVideos = (videos) => {
    return {
        type: types.APPEND_VIDEOS,
        videos: videos
    }
}

const setShowMoreVideos = (show) => {
    return {
        type: types.SET_SHOW_MORE_VIDEOS,
        show: show
    }
}

const setSearchingVideos = (searching) => {
    return {
        type: types.SET_SEARCHING_VIDEOS,
        searching: searching
    }
}

const setSearchPhrase = (searchPhrase) => {
    return {
        type: types.SET_SEARCH_PHRASE,
        searchPhrase: searchPhrase
    }
}

const setVideosFresh = (fresh) => {
    return {
        type: types.SET_VIDEOS_FRESH,
        fresh: fresh,
    }
}

const removeVideoItem = (videoId) => {
    return {
        type: types.REMOVE_VIDEO_ITEM,
        videoId: videoId
    }
}

const removeVideoExport = (videoId, exportId) => {
    return {
        type: types.REMOVE_VIDEO_EXPORT,
        videoId: videoId,
        exportId: exportId
    }
}

const updateExportProgress = (videoId, exportId, progress) => {
    return {
        type: types.UPDATE_EXPORT_PROGRESS,
        videoId: videoId,
        exportId: exportId,
        progress: progress
    }
}

const setExportStatus = (videoId, exportId, status) => {
    return {
        type: types.SET_EXPORT_STATUS,
        videoId: videoId,
        exportId: exportId,
        status: status
    }
}

// SMART OPERATIONS

const requestVideosPage = (skip, searchPhrase) => {
    // An empty phrase is left out of the query string, so the server returns every video.
    return axios.get('api/media/GetVideos/' + skip, { params: { searchPhrase: searchPhrase || undefined } });
}

const receiveVideosPage = (videos, append) => {
    return dispatch => {
        append ? dispatch(appendVideos(videos)) : dispatch(updateVideos(videos));
        dispatch(setVideosFresh(true));
        dispatch(setShowMoreVideos(videos.length >= videosPageConstants.VIDEOS_PAGE_SIZE));
    }
}

const getVideos = (skip, append = false) => {
    return (dispatch, getState) => {
        append ? dispatch(setAppendingVideos(true)) : dispatch(setLoadingVideos(true));

        // Reloads keep the active search, so loading more, cloning or deleting
        // never mixes unfiltered videos into a filtered list.
        const { searchPhrase } = getState().video;

        requestVideosPage(skip, searchPhrase).then(response => {
            dispatch(receiveVideosPage(response.data.videos, append));
        }).catch(error => {
            dispatch(appOperations.failRequest(error, () => getVideos(skip, append), 'Could not load your videos.'));
            dispatch(setShowMoreVideos(false));
        }).finally(() => {
            dispatch(setLoadingVideos(false));
            dispatch(setAppendingVideos(false));
        });
    }
}

const searchVideos = (searchPhrase) => {
    return dispatch => {
        const trimmedSearchPhrase = searchPhrase.trim();
        dispatch(setSearchingVideos(true));

        requestVideosPage(0, trimmedSearchPhrase).then(response => {
            // The phrase is stored together with its results, so a failed search leaves
            // the previous results and the phrase they were filtered by untouched.
            dispatch(setSearchPhrase(trimmedSearchPhrase));
            dispatch(receiveVideosPage(response.data.videos, false));
        }).catch(error => {
            dispatch(appOperations.failRequest(error, () => searchVideos(searchPhrase), 'Could not search your videos.'));
        }).finally(() => {
            dispatch(setSearchingVideos(false));
        });
    }
}

const cloneVideo = (videoId) => {
    return dispatch => {
        dispatch(setLoadingVideos(true));
        axios.post('api/media/CloneVideo/' + videoId).then(response => {
            dispatch(getVideos(0));

            trackEvent('Cloned Video', {
                videoId: videoId,
                clonedVideoId: response.data.videoId,
                category: AnalyticsConstants.VIDEO_CATEGORY,
            });
        }).catch(error => {
            dispatch(appOperations.failRequest(error, () => cloneVideo(videoId), 'Could not clone video.'));
            dispatch(setLoadingVideos(false));
        });
    }
}

const deleteVideo = (videoId) => {
    return dispatch => {
        dispatch(setLoadingVideos(true));
        axios.post('api/media/DeleteVideo/' + videoId).then(response => {
            dispatch(getVideos(0));
            dispatch(createActions.getVideoSettings());

            trackEvent('Deleted Video', {
                videoId: videoId,
                category: AnalyticsConstants.VIDEO_CATEGORY,
            });
        }).catch(error => {
            dispatch(appOperations.failRequest(error, () => cloneVideo(videoId), 'Could not delete video.'));
            dispatch(setLoadingVideos(false));
        });
    }
}

export default {
    setProperty,
    getVideos,
    searchVideos,
    cloneVideo,
    deleteVideo,
    updateVideos,
    setVideosFresh,
    removeVideoItem,
    removeVideoExport,
    updateExportProgress,
    setExportStatus
}